import CommHandler from './CommHandler';
import { config } from '../config';
import { getAuthHeader } from './utils';

const checkSuperadminStatus = async (email: string): Promise<boolean> => {
  try {
    const response = await CommHandler.request({
      url: `${config.adminApiURL}/admin/user/checkSuperadmin`,
      method: 'Post',
      headers: getAuthHeader,
      data: { email },
    });
    return response.data.isSuperadmin;
  } catch (error) {
    console.error('Error checking superadmin status:', error);
    return false;
  }
};

export default checkSuperadminStatus;
